<template>
    <div class="vue-container container" :class="[$common.lang]">
		<header>
		    <div class="back" @click="back('/',{})"></div>
		    <div class="title"></div>
		</header>
		<div class="content">
			<div v-if="status">
				<div class="status status-success"></div>
				<div class="result">{{$t('购买成功')}}</div>
			</div>
			<div v-if="!status">
				<div class="status status-failed"></div>
				<div class="result">{{$t('支付失败')}}</div>
			</div>
		</div>
		<div class="bottom" v-if="status">
				<div class="buy-botton" @click="openApp('superchinese')">{{$t('打开APP学习')}}</div>
		</div>
	</div>
</template>

<script>
import {
    getQueryString,
    invokeApp,
    setStorage,
    getStorage,
    clearStorage,
    removeStorage,
} from "@/util";
	export default {
	    name: "result",
	    mixins: [
		],
	    data() {
	        return {
				number:getStorage('number') ? getStorage('number') : 0,
				status:false,
				interval: null,
			}
		},
		watch: {
			status(val, old) {
				if(val && this.interval != null){
					clearInterval(this.interval)
					return
				}
				if(!val && this.interval == null){
					this.interval = setInterval(() => {
					    this.detail(this.number)
					}, 1000)
				}
			},
		},
		mounted(){
			this.detail(this.number)
		},
		methods: {
			back(path = '/', query = {}){
				this.$router.push({
					path: path,
					query: query,
				})
			},
			detail(number) {
				var that = this
				this.$fetch(this.$common.apis['orderDetail'] + '?number=' + number).then(data => {
					this.status = 0
					if (data && data.status == 3) {
						that.status = true
					}
				})
			},
			openApp(app){
				window.location.href='superchinese://index'
			}
		}
	}
</script>

<style lang="stylus" scoped="scoped">
	.container{
		.content{
			.status{
				display: block;
				width: 7.706666rem;
				height: 7.28rem;
				margin: 1.066666rem auto auto auto;
				background-size: contain;
				background-position center
				background-repeat no-repeat
				&.status-success{
					background-image: url(../assets/img/27.png);
				}
				&.status-failed{
					background-image: url(../assets/img/28.png);
					background-size: 90%;
				}
			}
			.result{
				text-align center
				font-size: 0.533333rem;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #FF9C2F;
				line-height: 0.746666rem;
			}
		}
		.bottom{
				width 100%
				position fixed
				bottom 0
			.buy-botton{
				margin 0 0.533333rem 1.786666rem 0.533333rem
				height: 1.28rem;
				background: linear-gradient(90deg, #FEB040 0%, #FD6A00 100%);
				border-radius: 0.64rem;
				display flex
				justify-content center
				align-items center
				font-size: 0.48rem;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
			}
		}
	}
	.ug{
	   text-orientation: sideways;
	   direction: rtl;
	}
</style>
